import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Necesito experiencia previa en electricidad?',
  answer: 'No, la guía está diseñada para principiantes y también para técnicos que quieren reforzar sus conocimientos.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Inmediatamente después de tu compra recibirás acceso digital (PDF) que puedes descargar en cualquier dispositivo.'
}, {
  question: '¿Funciona en mi país?',
  answer: 'Sí, los principios de comandos eléctricos son universales. La guía aplica para cualquier país.'
}, {
  question: '¿Qué pasa si no me gusta?',
  answer: 'Tienes 30 días de garantía. Si no estás satisfecho, te devolvemos el 100% de tu dinero sin preguntas.'
}, {
  question: '¿Incluye los bonos mencionados?',
  answer: 'Sí, todos los bonos están incluidos sin costo adicional cuando compras hoy.'
}, {
  question: '¿Puedo acceder desde mi celular?',
  answer: 'Sí, el material es compatible con cualquier dispositivo: celular, tablet o computadora.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 px-4 bg-[#FFFBEB]" data-id="element-117">
      <div className="max-w-3xl mx-auto" data-id="element-118">
        <h2 className="text-center text-[24px] md:text-[32px] font-black text-gray-900 mb-10 font-[Poppins,_sans-serif]" data-id="element-119">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-120">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-[#F0EBE0] rounded-2xl overflow-hidden shadow-[0_2px_10px_rgba(0,0,0,0.04)]" data-id="element-121">
              <button onClick={() => toggleFaq(index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left focus:outline-none cursor-pointer" data-id="element-122">
                <span className="font-bold text-gray-900 pr-4 text-[15px] md:text-[17px]" data-id="element-123">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#D9A441] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-124" />
              </button>

              <AnimatePresence data-id="element-125">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-126">
                    <div className="px-5 md:px-6 pb-5 md:pb-6 text-gray-600 text-sm md:text-base leading-relaxed border-t border-gray-50 pt-4" data-id="element-127">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}